export default (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        userData: action.stateData.userData,
        workspaces: action.stateData.workspaces,
        currentWorkspace: action.stateData.defaultWorkspace,
        spotlights: action.stateData.defaultWorkspace.spotlights,
      };

    case "ADD_SPOTLIGHT":
      return {
        ...state,
        spotlights: [...state.spotlights, action.spotlightData],
      };

    case "SET_CURRENT_SPOTLIGHT":
      // console.log("setting current spotlight", action.spotlight);
      return {
        ...state,
        currentSpotlight: {
          ...action.spotlight,
        },
      };

    case "CLEAR_CURRENT_SPOTLIGHT":
      return {
        ...state,
        currentSpotlight: null,
      };

    case "SET_ACTIVE_SPOTLIGHT":
      return {
        ...state,
        currentSpotlight: {
          ...state.currentSpotlight,
          isActive: true,
        },
      };

    case "DEACTIVATE_SPOTLIGHT":
      return {
        ...state,
        currentSpotlight: {
          ...state.currentSpotlight,
          isActive: false,
        },
      };

    case "SET_SPOTLIGHTS":
      return {
        ...state,
        spotlights: action.spotlightArray,
      };

    case "LOGOUT":
      return action.initialState;

    case "INIT_USER":
      //console.log("in reducer", action.userData);
      return {
        ...state,
        userData: action.userData,
      };

    case "ADD_WORKSPACE":
      return {
        ...state,
        workspaces: [...state.workspaces, action.workspaceData],
        currentWorkspace: action.workspaceData,
      };

    case "UPDATE_USER":
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.updatedUserData,
        },
      };

    case "SET_CURRENT_WORKSPACE":
      return {
        ...state,
        currentWorkspace: action.currentWorkspace,
      };

    case "UPDATE_WORKSPACE":
      return {
        ...state,
        currentWorkspace: {
          ...state.currentWorkspace,
          name: action.name,
        },
      };

    case "SET_WORKSPACES":
      return {
        ...state,
        workspaces: action.workspaces,
      };

    case "SET_ROLES":
      return {
        ...state,
        userData: {
          ...state.userData,
          roles: action.roles,
        }
      };

    case "SET_CURRENT_PLAN":
      return {
        ...state,
        currentWorkspace: {
          ...state.currentWorkspace,
          currentPlan: action.planId,
          hasBillingCard: true,
        }
      };

    default:
      console.log("No case matched, returning existing state");
      console.log(state);
      return state;
  }
};
